__turbopack_context__.v({
  "band": "Bmpu0G_band",
  "bandPrice": "Bmpu0G_bandPrice",
  "cell": "Bmpu0G_cell",
  "head": "Bmpu0G_head",
  "numeric": "Bmpu0G_numeric",
  "price": "Bmpu0G_price",
  "row": "Bmpu0G_row",
  "rows": "Bmpu0G_rows",
  "table": "Bmpu0G_table",
  "tableWrap": "Bmpu0G_tableWrap",
});
